<div class="main-container">

  <div class="title">
    <span class="title-text">Dashboard</span>
    <p class="small-title">Provisioning queue and capacity overview.</p>
  </div>

  <div class="count-cards">
    <div class="count-card">
      <span class="count-label">Open in working window</span>
      <span class="count-value">{{ workingWindowOpen }}</span>
    </div>
    @if(stats){
    <div class="count-card">
      <span class="count-label">Check-ins today</span>
      <span class="count-value">{{ stats.actualCheckIns }}</span>
      <span class="count-sub">of {{ stats.totalCheckIns }} expected</span>
    </div>
    <div class="count-card">
      <span class="count-label">Check-outs today</span>
      <span class="count-value">{{ stats.actualCheckOuts }}</span>
      <span class="count-sub">of {{ stats.totalCheckOuts }} expected</span>
    </div>
    <div class="count-card">
      <span class="count-label">Guests today</span>
      <span class="count-value">{{ stats.totalGuestCount }}</span>
    </div>
    }
  </div>

  <div class="daily-reports">
    <div class="reports-head">
      <span class="reports-title">Daily reports</span>
      <p class="small-title">Download the day's confirmed bookings or room allocations.</p>
    </div>
    <div class="reports-controls">
      <div class="filter-field">
        <span class="filter-label">Date</span>
        <input type="date" class="text-box-active" [(ngModel)]="reportDate" />
      </div>
      <button type="button" class="ac-secondary-btn export-btn" [disabled]="isExporting" (click)="exportConfirmed('csv')">Confirmed CSV</button>
      <button type="button" class="ac-secondary-btn export-btn" [disabled]="isExporting" (click)="exportConfirmed('pdf')">Confirmed PDF</button>
      <button type="button" class="ac-secondary-btn export-btn" [disabled]="isExporting" (click)="exportAllocations('csv')">Allocations CSV</button>
      <button type="button" class="ac-secondary-btn export-btn" [disabled]="isExporting" (click)="exportAllocations('pdf')">Allocations PDF</button>
    </div>
  </div>

  <div class="section-title">Capacity by date</div>
  <div class="table-container">
    <table class="table">
      <thead class="table-head">
        <tr>
          <th>Date</th>
          <th>Type</th>
          <th>Online rooms (avail/max)</th>
          <th>Waitlist (avail/max)</th>
          <th>Manual dorms (avail/max)</th>
          <th>Manual rooms (avail/max)</th>
        </tr>
      </thead>
      <tbody class="table-body">
        @for(row of openRows; track row.provisioningDate){
        <tr>
          <td>{{ row.provisioningDate }}</td>
          <td>{{ row.provisioningType || '-' }}</td>
          <td>{{ row.onlineRoomAvailableCapacity }} / {{ row.onlineRoomMaxStayCapacity }}</td>
          <td>{{ row.onlineRoomWlAvailableCapacity }} / {{ row.onlineRoomWlMaxStayCapacity }}</td>
          <td>{{ row.manualDormAvailableCapacity }} / {{ row.manualDormMaxStayCapacity }}</td>
          <td>{{ row.manualRoomAvailableCapacity }} / {{ row.manualRoomMaxStayCapacity }}</td>
        </tr>
        }
        @if(!isLoading && openRows.length === 0){
        <tr>
          <td colspan="6" class="empty-row">No capacity data.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>

</div>

<app-loader [isLoading]="isLoading"></app-loader>
